<template>
  <div style="padding: 0 30px;" v-if="lossDeterm">
    <div style="display: flex; padding-bottom: 10px" v-if="quick">
      <div style="flex-grow: 1"></div>
      <el-tag effect="light" style="border-radius: 10px">快修</el-tag>
    </div>

    <el-table v-show="!quick" :data="lossDeterm.partsList" height="342" style="border: 1px solid darkgrey">
      <el-table-column label="定损部件" prop="name">
      </el-table-column>
      <el-table-column align="center" label="拆检" width="80">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isDisassembly"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="钣金" width="80">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isSheetMetal"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="喷漆" width="80">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isPaint"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="钣金损伤程度" width="110">
        <template #default="{ row }">
          {{row.isSheetMetal ? sheetMetalDamageDegreeMap[row.sheetMetalDegree] : ''}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="喷漆损伤程度" width="110">
        <template #default="{ row }">
          {{row.isPaint ? paintDamageDegreeMap[row.paintDegree] : ''}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="钣金工时" prop="sheetMetalWH" width="90">
        <template #default="{ row }">
          {{(row.isSheetMetal || row.isDisassembly) ? row.sheetMetalWH + row.disassemblyWH + row.assemblyWH : ''}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="油漆幅数" prop="paintArea" width="90">
        <template #default="{ row }">
          {{row.isPaint ? row.paintArea : ''}}
        </template>
      </el-table-column>
      <el-table-column :width="isRead ? 1 : 80" align="center">
        <template #header>
          <el-button @click="showLostDetermDialog = true" icon="el-icon-plus" type="primary"></el-button>
        </template>
        <template #default="{ $index, row }">
          <el-button :disabled="row.fixed" @click="deleteParts($index)" icon="el-icon-delete-solid"
                     type="text"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-show="quick" :data="lossDeterm.partsList" style="height: 300px; border: 1px solid darkgrey">
      <el-table-column label="定损部件" prop="name">
      </el-table-column>
      <el-table-column align="center" label="油漆幅数" prop="paintArea">
        <template #default="{ row }">
          {{row.isPaint ? row.paintArea : ''}}
        </template>
      </el-table-column>
      <el-table-column :width="isRead ? 1 : 80" align="center">
        <template #header>
          <el-button @click="showLostDetermDialog = true" icon="el-icon-plus" type="primary"></el-button>
        </template>
        <template #default="{ $index, row }">
          <el-button :disabled="row.fixed" @click="deleteParts($index)" icon="el-icon-delete-solid"
                     type="text"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 20px; display: flex; justify-content: space-around">
      <div v-show="!quick">
        <label class="label" style="margin-right: 10px">维修钣件</label>
        <label>{{lossDeterm.sheetMetalPiece}}</label>
      </div>
      <div>
        <label class="label" style="margin-right: 10px">油漆幅数</label>
        <label>{{lossDeterm.paintArea.toFixed(2)}}</label>
      </div>
      <div v-show="!quick">
        <label class="label" style="margin-right: 10px">钣金工时</label>
        <label>{{sheetMetalWH.toFixed(2)}}</label>
      </div>
      <div>
        <label class="label" style="margin-right: 10px">油漆工时</label>
        <label>{{lossDeterm.paintWH.toFixed(2)}}</label>
      </div>
      <div>
        <label class="label" style="margin-right: 10px">维修费用</label>
        <label v-if="isRead">{{lossDeterm.cost.toFixed(2)}}</label>
        <el-input size="mini" style="width: 90px" v-else v-model.number="lossDeterm.cost"
                  oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
      </div>
    </div>
    <loss-determ-dialog :selected-parts-list="lossDeterm.partsList||[]" :visible.sync="showLostDetermDialog"
                        @update:selectedPartsList="updatePartList($event)"
                        :repair-type="lossDeterm.repairType"
                        :is-add-parts="isAddParts"
                        :work="work">
    </loss-determ-dialog>
  </div>
</template>

<script>
  import LossDetermDialog from '@/views/kanban/dialog/add-check/LossDetermDialog'
  import { shareDataMixin } from '@/views/mixins/ShareData'

  export default {
    name: 'LossDetermPanel',
    mixins: [shareDataMixin],
    components: {
      LossDetermDialog
    },
    props: {
      lossDeterm: {
        required: true
      },
      pattern: {
        type: String,
        required: true
      },
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        showLostDetermDialog: false
      }
    },
    methods: {
      deleteParts (index) {
        this.lossDeterm.partsList.splice(index, 1)
        this.updateWH()
        this.updatePrice()
      },
      updatePartList ({ repairType, partsList }) {
        this.lossDeterm.repairType = repairType
        this.lossDeterm.partsList = partsList
        this.updateWH()
        this.updatePrice()
      },
      updateWH () {
        let disassemblyWH = 0
        let sheetMetalWH = 0
        let assemblyWH = 0
        let paintWH = 0
        let paintArea = 0
        let sheetMetalPiece = 0

        for (const parts of this.lossDeterm.partsList) {
          if (!this.quick) {
            disassemblyWH += parts.disassemblyWH
            sheetMetalWH += parts.sheetMetalWH
            assemblyWH += parts.assemblyWH
            sheetMetalPiece += (parts.isDisassembly || parts.isSheetMetal) ? 1 : 0
          }
          paintArea = this.tosalAdd(paintArea, parts.paintArea)
          paintWH += this.tosalMul(parts.paintArea, this.work.basicPaintWorkHour)
        }
        this.lossDeterm.sheetMetalPiece = sheetMetalPiece
        this.lossDeterm.disassemblyWH = disassemblyWH
        this.lossDeterm.sheetMetalWH = sheetMetalWH
        this.lossDeterm.assemblyWH = assemblyWH
        this.lossDeterm.paintArea = paintArea
        this.lossDeterm.paintWH = paintWH
      },
      updatePrice () {
        let sumPrice = 0
        if (this.quick) {
          for (const parts of this.lossDeterm.partsList) {
            sumPrice += this.partsCoeMap[parts.id].quickCoe[1]
          }
        } else {
          for (const parts of this.lossDeterm.partsList) {
            if (parts.isDisassembly) {
              sumPrice += this.partsCoeMap[parts.id].disassemblyCoe[1]
            }
            if (parts.isSheetMetal) {
              sumPrice += this.partsCoeMap[parts.id].sheetMetalCoe[parts.sheetMetalDegree][1]
              sumPrice += this.partsCoeMap[parts.id].assemblyCoe[1]
            }
            if (parts.isPaint) {
              sumPrice += this.partsCoeMap[parts.id].paintCoe[parts.paintDegree][1]
            }
          }
        }
        this.lossDeterm.cost = sumPrice.toFixed(2)
      },
      tosalAdd (arg1, arg2) { // 精准加法
        var r1, r2, m
        try {
          r1 = arg1.toString().split('.')[2].length
        } catch (e) {
          r1 = 0
        }
        try {
          r2 = arg2.toString().split('.')[2].length
        } catch (e) {
          r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
      },
      tosalMul (arg1, arg2) { // 精准乘法
        var m = 0
        var s1 = arg1.toString()
        var s2 = arg2.toString()
        try {
            m += s1.split('.')[2].length
        } catch (e) {}
        try {
            m += s2.split('.')[2].length
        } catch (e) {}

        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
      }
    },
    computed: {
      isRead () {
        return this.pattern === 'READ'
      },
      isEdit () {
        return this.pattern === 'EDIT'
      },
      isAddParts () {
        return this.pattern === 'ADD_PARTS_IN_WORK'
      },
      quick () {
        return this.lossDeterm.repairType === 'QUICK'
      },
      sheetMetalWH () {
        return this.lossDeterm.disassemblyWH * 1 + this.lossDeterm.sheetMetalWH * 1 + this.lossDeterm.assemblyWH * 1
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    height: 28px;
    line-height: 28px;
  }
</style>
